<script setup lang="ts">
	import type { ListContext } from '@/components/Shared/list-item.vue'

	withDefaults(
		defineProps<{
			summary?: ListContext
			title?: string
			desc?: string
			btnText?: string
			isLoading?: boolean
			bodyClass?: string
		}>(),
		{
			title: 'Business Account Created!',
			desc: 'Your business account has been created successfully!',
			btnText: 'Proceed to plan details'
		}
	)

	const emit = defineEmits<{
		(arg: 'done'): void
		(arg: 'update:isLoading', param: boolean): void
	}>()

	const proceed = () => {
		emit('done')
	}
</script>

<template>
	<div>
		<header class="header mb-[2rem] flex flex-col items-center text-center">
			<lazy-tools-icon icon="success-check" :height="154" :width="226.009" dir="fill" class="mb-5" />

			<h4 class="mb-2 text-[28px] font-semibold text-blue-950">
				{{ title }}
			</h4>

			<p class="max-w-sm text-center text-base font-medium text-gray-500">
				{{ desc }}
			</p>
		</header>

		<slot name="body">
			<div v-if="summary" class="rounded-lg border border-purple-100 bg-purple-25">
				<shared-list-item class="w-full" :lists="summary" />
			</div>
			<div v-else class="mb-20" />
		</slot>

		<div class="my-4 mt-8 flex items-center justify-center">
			<a-button :loading="isLoading" class="default-btn w-full justify-center bg-primary-2" @click="proceed">
				{{ btnText }}
			</a-button>
		</div>
	</div>
</template>
